export const CURRENCY_SYMBOLS = { USD: "$", EUR: "€" };
export const CURRENCY_NAMES = { USD: "Dólar", EUR: "Euro" };

export const getCurrencySymbol = (iso) => CURRENCY_SYMBOLS[iso] || "$";
export const getCurrencyName = (iso) => CURRENCY_NAMES[iso] || "Dólar";

const truncateNumber = (value, decimals = 6) => {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    return "";
  }

  const factor = 10 ** decimals;
  return Math.trunc(numericValue * factor) / factor;
};

export const truncateAmount = (rawValue, decimals = 6) => {
  const numericValue = normalizeAmount(rawValue);
  if (numericValue === "") {
    return "";
  }

  return truncateNumber(numericValue, decimals);
};

export const formatAmountTruncated = (rawValue, decimals = 2) => {
  const truncated = truncateAmount(rawValue, decimals);
  if (truncated === "") {
    return "";
  }

  return Number(truncated).toFixed(decimals);
};

export const roundAmount = (rawValue, decimals = 2) => {
  const numericValue = normalizeAmount(rawValue);
  if (numericValue === "") {
    return "";
  }

  const factor = 10 ** decimals;
  const sign = numericValue < 0 ? -1 : 1;
  const scaled = Number((Math.abs(numericValue) * factor).toPrecision(12));
  return (sign * Math.round(scaled)) / factor;
};

export const formatAmountRounded = (rawValue, decimals = 2) => {
  const rounded = roundAmount(rawValue, decimals);
  if (rounded === "") {
    return "";
  }

  return Number(rounded).toFixed(decimals);
};

export const formatAmountForBackend = (rawValue, decimals = 6) => {
  const numericValue = normalizeAmount(rawValue);

  if (numericValue === "") {
    return "";
  }

  const isNegative = Number(numericValue) < 0;
  const absoluteString = Math.abs(Number(numericValue)).toString();
  const [integerPart, decimalPart = ""] = absoluteString.split(".");
  const truncatedDecimal = decimalPart.slice(0, decimals).padEnd(decimals, "0");

  return `${isNegative ? "-" : ""}${integerPart || "0"}.${truncatedDecimal}`;
};

export const normalizeAmount = (rawValue) => {
  if (rawValue === null || rawValue === undefined || rawValue === "") {
    return "";
  }

  const numericValue = Number(String(rawValue).replace(",", "."));
  return Number.isFinite(numericValue) ? numericValue : "";
};

export const convertToUsd = (amount, isUsdCurrency, exchangeRate) => {
  const numericAmount = normalizeAmount(amount);

  if (numericAmount === "") {
    return "";
  }

  if (!isUsdCurrency) {
    if (!exchangeRate || exchangeRate <= 0) {
      return "";
    }

    return truncateNumber(numericAmount / exchangeRate, 6);
  }

  return truncateNumber(numericAmount, 6);
};

export const convertFromUsd = (usdAmount, isUsdTargetCurrency, exchangeRate) => {
  const numericUsdAmount = normalizeAmount(usdAmount);

  if (numericUsdAmount === "") {
    return "";
  }

  if (!isUsdTargetCurrency) {
    if (!exchangeRate || exchangeRate <= 0) {
      return "";
    }

    return truncateNumber(numericUsdAmount * exchangeRate, 6);
  }

  return truncateNumber(numericUsdAmount, 6);
};